import type { AxiosRequestConfig } from 'axios'

import { HttpService } from '@/infra'
import type { TUnidadesDeNegocioDisponiveisResponse } from '@/types/unidade-negocio'

export class GetUnidadeDeNegocioService extends HttpService {
  execute = async () => {
    return this.http.get<TUnidadesDeNegocioDisponiveisResponse, AxiosRequestConfig>(
      `api/v2/UnidadeDeNegocio/disponiveis`,
    )
  }
}
